import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

// props
interface IProps {
	value?: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterNumber',
  props: {
    value: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	value?: any;
};



// computed
const isInvalid = computed<boolean>(() => {
	return number.value <= 0;
});

// data
const number = ref<number>(props.value ?? 0);

// expose
expose({ isInvalid });

return { __sfc: true,props, isInvalid, number }
}

})